import { useRouter } from "next/router";
import React from "react";

const useModal = () => {
  const [modal, setModal] = React.useState(false);
  const [modalContent, setModalContent] = React.useState("I'm the Modal Content");
  const router = useRouter();
  const modalRef = React.useRef(modal);

  React.useEffect(() => {
    modalRef.current = modal;
  }, [modal]);

  React.useEffect(() => {
    const currentPath = router.asPath.split("?")[0];
    const isMultimediaDetailPath = /^\/multimedia\/.+/.test(currentPath);

    // If URL moved away from multimedia detail, ensure routed modal is closed.
    if (modalRef.current && !isMultimediaDetailPath) {
      setModal(false);
    }
  }, [router.asPath]);

  const closeModal = React.useCallback(() => {
    setModal(false);
  }, []);

  const handleModal = React.useCallback((content?: any) => {
    // Open modal only when content is provided.
    if (content) {
      setModalContent(content);
      setModal(true);
      return;
    }

    // Close/no-op path for callers that invoke handleModal() with no content.
    if (!modalRef.current) return;

    closeModal();

    // Routed multimedia modal should navigate back when closed.
    const currentPath = router.asPath.split("?")[0];
    if (/^\/multimedia\/.+/.test(currentPath)) {
      router.back();
    }
  }, [closeModal, router]);

  return { modal, handleModal, modalContent, closeModal };
};

export default useModal;
